import '../payout.scss';

import { Button, Divider, Dropdown } from '@basqet-dashboard/common/components';
import { useCurrencies } from '@basqet-dashboard/common/hooks';
import { copyToClipboard, useNavigateTo } from '@basqet-dashboard/common/utils';
import { useFetchPayoutReceiveWallets } from '@hooks/queries';
import React, { useState } from 'react';
import QRCode from 'react-qr-code';

import { BackButton } from '../back-button';
import { SelectedWallet } from '../selected-wallet';
import { PayoutRecentTransactions } from '../single-transfer-page/payout-recent-transactions';

const ReceivePayoutPage = () => {
  const [selectedWallet, setSelectedWallet] = useState({});

  const { wallets } = useFetchPayoutReceiveWallets();

  const { cryptoCurrencies } = useCurrencies();

  const handleChange = (e) => {
    const { value } = e.target;

    const chosenWallet = wallets.find((wallet) => parseInt(wallet.currency_id) === parseInt(value));

    setSelectedWallet(chosenWallet);
  };

  const walletAddress = selectedWallet?.address;
  const currencyId = selectedWallet?.currency_id;

  const { navigateTo } = useNavigateTo();

  return (
    <section className="payout">
      <div className="card payout__receive">
        <BackButton onClick={() => navigateTo('/payouts')} />
        <h3 className="card__header">Receive Crypto Payments </h3>

        <SelectedWallet label="Available Balance" currencyId={currencyId} />

        <Dropdown
          formLabel="Payment Currency"
          name="currency_id"
          options={cryptoCurrencies}
          register={{ onChange: handleChange }}
          defaultValue={currencyId}
          placeholder="Select payment currency"
        />

        {walletAddress && (
          <>
            <div className="payout__receive__wallet-address">
              <div>
                <p className="form__label">Deposit Address</p>
                <p>
                  <b>{walletAddress}</b>
                </p>
              </div>
              <Button
                size="small"
                variant="jelly-green"
                onClick={() => copyToClipboard('Wallet Address', walletAddress)}>
                Copy
              </Button>
            </div>
            <Divider text="or" />
            <div className="qr__container">
              <p>Scan QR Code</p>
              <QRCode
                value={walletAddress}
                style={{ width: '119', height: '119', margin: '1.6rem auto', display: 'block' }}
                viewBox={`0 0 256 256`}
              />
            </div>
          </>
        )}
      </div>

      <PayoutRecentTransactions />
    </section>
  );
};

export { ReceivePayoutPage };
